import React from 'react'

export default function BackButton(props) {
    return <button className='btn btn-primary w-100' onClick={() => props.setActive("")}>Tilbake</button>
}